<template>
  <div class="modal-device-setting-component">
    <div class="modal-device-setting">
      <!--      <component-->
      <!--          ref="deviceInfo"-->
      <!--          v-if="isDevicetest"-->
      <!--          :is="infoComponent"-->
      <!--          :roomInfo="roomInfo"-->
      <!--          :isShowInfo.sync="isShowInfo"-->
      <!--          @reqJoin="reqJoin"-->
      <!--          @reqApproveJoin="reqApproveJoin"-->
      <!--      />-->
      <img class="device-set-preview-gooroomee-header" v-if="!isMobile && isDevicetest" src="@/assets/images/camstudy/preview_gooroomee_name.svg" />
      <CamstudyPreview
          ref="devicePreview"
          :roomInfo="roomInfo"
          :isShowCoachmark="isShowCoachmark"
          :isDevicetest="isDevicetest"
          @onToggleInfo="toggleInfo"
          @reqJoin="reqJoin"
          @reqApproveJoin="reqApproveJoin"
          @onUpdatePreview="onUpdatePreview"
          @onUpdateNickname="onUpdateNickname"
      />
    </div>

    <!--    <ModalDeviceSettingCoachmark-->
    <!--        v-if="isShowCoachmark"-->
    <!--        :isShowCoachmark.sync="isShowCoachmark"-->
    <!--    />-->
  </div>
</template>

<script>

// import ModalDeviceSettingCoachmark from '@/components/Room/DeviceSetting/Coachmark'
import DeviceSettingInfo from '@/components/Room/DeviceSetting/Info/DeviceSettingInfo'
import DeviceSettingInfoWaiting from '@/components/Room/DeviceSetting/Info/DeviceSettingInfoWaiting'
// import DeviceSettingPreview from '@/components/Room/DeviceSetting/Preview'
import CamstudyPreview from "@/components/Room/DeviceSetting/coordi/CamstudyPreview.vue"
import {roomRecordApi} from "@/core/api/room.record.api";
import {mapActions, mapMutations, mapState} from "vuex";
import {Device} from "@/utils";

export default {
  name: 'CamstudyDeviceSetting',
  components: {
    // ModalDeviceSettingCoachmark,
    // DeviceSettingInfo,
    // DeviceSettingInfoWaiting,
    CamstudyPreview,
  },
  props: {
    roomInfo: Object,
    deviceSettings: Object,
    isDevicetest: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      isInit: false,
      isShowCoachmark: true,
      isShowInfo: true,
      isWaitingRoom: false,
    }
  },
  computed: {
    infoComponent() {
      return this.enabled ? 'DeviceSettingInfoWaiting' : 'DeviceSettingInfo'
    },
    ...mapState('waitingRoom', ['enabled', 'deviceRequired']),
    isMobile() {
      return Device.isMobile();
    }
  },
  methods: {
    ...mapMutations('room',[
      'TOGGLE_MODAL_DEVICE_SETTING',
    ]),
    ...mapActions('waitingRoom',
        ['findAllByRoomIdApi', 'isEnabled', 'approveApi', 'disapproveApi', 'requestEnterApi',
          'disableWaitingRoomApi', 'leaveWaitingRoomApi', 'sendTestNoManagerInRoomApi', 'sendTestCloseRoomApi']),
    ...mapMutations('waitingRoom', [
      'CHANGE_ROLE_ID', 'ENTER_REQUESTED', 'ADD_WAITING_USER', 'APPROVAL', 'APPROVED',
      'DISAPPROVED', 'NO_PERMISSION', 'NO_MANAGER_IN_ROOM', 'ROOM_CLOSED',
      'SET_ENABLED', 'SET_DEVICE_REQUIRED'
    ]),
    closeModal(){
      if(!this._isDestroyed)
        this.TOGGLE_MODAL_DEVICE_SETTING(false)
    },
    toggleInfo() {
      this.isShowInfo = !this.isShowInfo
    },
    async reqJoin(saveCoordi){
      if(!this._isDestroyed){
        await this.$refs.devicePreview.deviceTestComplete();
        this.join(saveCoordi);
      }
    },
    async reqApproveJoin() {
      let settings = this.$refs.devicePreview.getNecessarySettings

      if(this.deviceRequired && (!settings.video.deviceId ||!settings.audio.deviceId)) {
        this.$alert({
          text: this.$t('deviceSetting.essential'),
          onlyOk: true
        })

        return;
      }

      this.$refs.deviceInfo.reqApproveJoin(settings)
    },
    onUpdatePreview({deviceType, device}){
      let d = this[deviceType]
      if (!d) return

      if (d.deviceId === device.deviceId) {
        return
      }
      this[deviceType] = device
    },
    join(saveCoordi) {
      try {
        let settings = this.$refs.devicePreview.getNecessarySettings

        roomRecordApi.setUserDevices(settings);
        this.$emit('deviceTestComplete', {settings, callFunc: saveCoordi})
        this.$parent && this.$parent.$emit('deviceTestComplete', {settings, callFunc: saveCoordi});
      } finally {
        this.closeModal()
      }
    },
    onUpdateNickname(nickname) {
      this.$emit('onUpdateReqEnterNickname', { nickname })
    }
  },
  watch: {
    enabled(val) {
    }
  },
}
</script>

<style lang="scss" scoped>
.modal-device-setting-component {
  width: 100%;
  height: 100%;
  display: grid;
  justify-content: center;
  align-items: center;
  overflow: auto;
  background-color: #141414;
}
.modal-device-setting {
  max-width: 960px;
  width: 100dvw;
  border-radius: 12px;
  display: flex;
  position: relative;
  overflow: hidden;
}

html:not([grm-device-mobile]){
  .modal-device-setting{
    flex-direction: column;
  }
  .device-set-preview-gooroomee-header{
    margin-bottom: 32px;
    height: 32px;
  }
}
[grm-device-mobile] {
  .modal-device-setting-component {
    display: flex;
  }
  .modal-device-setting {
    width: 100%;
    height: 100%;
    border-radius: 0;
  }
}
</style>